import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import useAuthStore from './stores/authStore';
import Layout from './components/Layout';
import Login from './pages/Login';
import Setup from './pages/Setup';
import Dashboard from './pages/Dashboard';
import Groups from './pages/Groups';
import GroupDetail from './pages/GroupDetail';
import GroupSettings from './pages/GroupSettings';
import Distribution from './pages/Distribution';
import MonthlyReport from './pages/MonthlyReport';
import Members from './pages/Members';
import MemberDetail from './pages/MemberDetail';
import Transactions from './pages/Transactions';
import ImportCsv from './pages/ImportCsv';
import Fines from './pages/Fines';
import Calendar from './pages/Calendar';
import Changiwa from './pages/Changiwa';
import ChangiwaDetail from './pages/ChangiwaDetail';
import Users from './pages/Users';
import Expenses from './pages/Expenses';
import GroupTransfers from './pages/GroupTransfers';
import AuditLog from './pages/AuditLog';
import SmsLogs from './pages/SmsLogs';
import Permissions from './pages/Permissions';
import GroupRequests from './pages/GroupRequests';
import Notifications from './pages/Notifications';
import SystemSettings from './pages/SystemSettings';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('mbegi_token');
  return token ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('mbegi_token');
  return token ? <Navigate to="/" replace /> : children;
};

export default function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={<PublicRoute><Login /></PublicRoute>}
        />
        <Route
          path="/setup"
          element={<PublicRoute><Setup /></PublicRoute>}
        />

        <Route
          path="/"
          element={<ProtectedRoute><Layout /></ProtectedRoute>}
        >
          <Route index element={<Dashboard />} />
          <Route path="groups" element={<Groups />} />
          <Route path="groups/:id" element={<GroupDetail />} />
          <Route path="groups/:id/settings" element={<GroupSettings />} />
          <Route path="groups/:id/distribution" element={<Distribution />} />
          <Route path="groups/:id/expenses" element={<Expenses />} />
          <Route path="groups/:id/group-transfers" element={<GroupTransfers />} />
          <Route path="groups/:id/monthly" element={<MonthlyReport />} />
          <Route path="groups/:id/notify" element={<Notifications />} />
          <Route path="members" element={<Members />} />
          <Route path="members/:id" element={<MemberDetail />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="transactions/import" element={<ImportCsv />} />
          <Route path="fines" element={<Fines />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="changiwa" element={<Changiwa />} />
          <Route path="changiwa/:id" element={<ChangiwaDetail />} />
          <Route path="users" element={<Users />} />
          <Route path="audit-log" element={<AuditLog />} />
          <Route path="sms-logs" element={<SmsLogs />} />
          <Route path="permissions" element={<Permissions />} />
          <Route path="group-requests" element={<GroupRequests />} />
          <Route path="system-settings" element={<SystemSettings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
